import { QUERY_KEYS } from "@cnx/common";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { queryInvalidationBus } from "./queryInvalidationBus";

export const useLiveInvalidation = (
  keys: QUERY_KEYS[] | (() => QUERY_KEYS[])
) => {
  const queryClient = useQueryClient();

  useEffect(() => {
    const resolvedKeys = typeof keys === "function" ? keys() : keys;

    resolvedKeys.forEach(key => {
      const listener = async (id?: string) => {
        if (id) {
          await queryClient.invalidateQueries({
            queryKey: [key, id],
          });
          return;
        }

        await queryClient.invalidateQueries({ queryKey: [key] });
      };

      queryInvalidationBus.subscribe(key, listener);
    });

    return () => {
      resolvedKeys.forEach(key => {
        queryInvalidationBus.unsubscribe(key);
      });
    };
  }, [queryClient, keys]);
};
